import { useMutation } from "react-query";
import { updateRolePermission } from "../../../../../actions/Utilities/ModuleManagement";

export const useUpdateRolePermission = () => {
  return useMutation(updateRolePermission);
};
export default useUpdateRolePermission;
